var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetNeed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.855,
    y1: 0.846,
    x2: 0.156,
    y2: 0.147,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2388e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_171",
    x: 0,
    y: 0,
    width: 256,
    height: 256,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 30,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1888",
    "data-name": "Group 1888",
    transform: "translate(-745 -334.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 745, 334.04)",
    filter: "url(#Ellipse_171)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171-2",
    "data-name": "Ellipse 171",
    cx: 68,
    cy: 68,
    r: 68,
    transform: "translate(60 30)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1887",
    "data-name": "Group 1887",
    transform: "translate(844.65 395.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M33,13.933h.69c3.049-.013,8.294,2.917,8.3,8.1l.371,10.447c.3,1.887-.719,2.923,1.2,2.911l9.525.988c1.12,0,1.867-2.4,1.734-3.511-.043-.362-.1-10.424-.193-10.987C54.525,8.554,43.659,1.518,33.712,1.52h-.75A21.227,21.227,0,0,0,11.75,22.658V33.533l-1.7.3L9.7,33.9A5.733,5.733,0,0,0,5,39.52V65.853a5.732,5.732,0,0,0,4.68,5.62l2.355.44a115.481,115.481,0,0,0,21.309,1.993,115.443,115.443,0,0,0,21.3-1.983l2.369-.443a5.732,5.732,0,0,0,4.68-5.62V39.52a5.732,5.732,0,0,0-4.68-5.62h0l-.338-.067A126.61,126.61,0,0,0,24.224,32v-9.33A8.769,8.769,0,0,1,33,13.933Zm.345,21.459A122.563,122.563,0,0,1,56.005,37.5l.335.067a2,2,0,0,1,1.628,1.956V65.853a2,2,0,0,1-1.628,1.956l-2.355.44a111.938,111.938,0,0,1-41.253,0l-2.355-.44A2,2,0,0,1,8.75,65.853V39.52a2,2,0,0,1,1.628-1.956l.345-.067a122.547,122.547,0,0,1,22.621-2.1ZM15.5,32.936V22.658A17.486,17.486,0,0,1,32.984,5.237h.75c7.736.012,17.2,6.042,17.2,16.612.036.18.1,11.028.146,11.43a.179.179,0,0,1-.045.149.15.15,0,0,1-.12.052h-4.7a.15.15,0,0,1-.15-.119c-.06-.375-.137-10.446-.287-11.024A12.078,12.078,0,0,0,33.7,10.223h-.69A12.511,12.511,0,0,0,20.466,22.666v9.666C18.8,32.481,17.136,32.7,15.5,32.936Z",
    transform: "translate(-5 -1.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M35.057,77.43a15.757,15.757,0,0,0,11.48,0h0a3.085,3.085,0,0,0,1.8-3.935L46.14,67.326a6.917,6.917,0,1,0-10.653,0l-2.234,6.169A3.093,3.093,0,0,0,35.057,77.43Zm3.927-12.171a2.918,2.918,0,1,1,3.625,0,1.987,1.987,0,0,0-.636,2.218L44.3,74a11.774,11.774,0,0,1-7,0l2.321-6.527A1.987,1.987,0,0,0,38.985,65.259Z",
    transform: "translate(-12.453 -17.326)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetNeed);
export default __webpack_public_path__ + "static/media/asset-need.e6e40bc99fbdcd2863ad42af6836ea5c.svg";
export { ForwardRef as ReactComponent };